// NL
export const airConditioningInstallationNL = {
  id: '27312f18-9760-4480-9c68-101265a2c480',
  identifier: 'air-conditioning-installation',
}
